// src/components/shared/ContactLink.js
import styled from 'styled-components';
import { colors } from '../colors';

const ContactLink = styled.a.withConfig({
  shouldForwardProp: (prop) => prop !== 'isBold'
})`
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: ${props => props.isBold ? 'bold' : 'normal'};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${colors.primaryDark} !important;
  }
  @media (max-width: 600px) {
    font-size: 0.85rem;
  }
`;

export default ContactLink;